import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, BTN_DARK_THEME, SIZE_44, TRAILING_ICON, GHOST_VARIANT, NO_ICON, } from '@yme/atoms/button';
import { Col, Row } from '@yme/atoms/grid';
import { CONFIGURATOR_PARAM_NAME, CONFIGURATOR_PARAM_VALUE_ON, PCM_CODE, PRODUCT_HAS_CONFIGURATOR, } from '@yme/common/constants';
import { useConfigurator } from '@yme/common/hooks/useConfigurator';
import { getIsKioskVersion } from '@yme/selectors/common';
import { getAttribute } from '@yme/selectors/products';
import { useTranslation } from '@yme/services/i18n';
import { ButtonsSectionStyled } from '../styled';
import { HeroPrice } from './HeroPrice';
export function HeroSectionButtonsPanel({ labels, configuratorLeadFormPagePath, isRightToLeft, currentColorTheme, hasForOwnersComponent, scrollToId, configuratorVersion, }) {
    const configurator = useConfigurator(configuratorLeadFormPagePath, configuratorVersion);
    const { t } = useTranslation();
    const history = useHistory();
    const productPCMCode = useSelector(getAttribute(PCM_CODE));
    const hasConfigurator = useSelector(getAttribute(PRODUCT_HAS_CONFIGURATOR));
    const isKioskVersion = useSelector(getIsKioskVersion);
    useEffect(() => {
        const queryParams = new URLSearchParams(history.location.search);
        if (!isKioskVersion &&
            queryParams.get(CONFIGURATOR_PARAM_NAME) === CONFIGURATOR_PARAM_VALUE_ON &&
            productPCMCode) {
            configurator.onConfiguratorHandler();
        }
    }, [configurator, history.location.search, isKioskVersion, productPCMCode]);
    return (React.createElement(Row, null,
        React.createElement(Col, { md: 8, lg: 12 },
            React.createElement(HeroPrice, { fromLabel: labels.common_from_label }),
            React.createElement(ButtonsSectionStyled, { currentColorTheme: currentColorTheme || '' },
                !isKioskVersion && hasConfigurator && (React.createElement(Button, { key: `${productPCMCode}_confBtn`, width: "unset", className: "configurator-button", hasIconButton: NO_ICON, buttonVariant: CONTAINED_VARIANT, size: SIZE_44, isRightToLeft: isRightToLeft, colorSchema: BTN_DARK_THEME, label: t('productCard_configurator_button'), onClick: configurator.onConfiguratorHandler })),
                hasForOwnersComponent && (React.createElement(Button, { width: "unset", buttonVariant: GHOST_VARIANT, size: SIZE_44, colorSchema: BTN_DARK_THEME, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, label: labels.pdpHeroSection_learnMore_button, onClick: scrollToId }))))));
}
